import {Component, OnDestroy, OnInit} from '@angular/core';
import {ToastMessageService} from "../../services/toast-message.service";
import {ActivatedRoute} from "@angular/router";
import {Subscription} from "rxjs";
import {AuthenticationService} from "../authentication.service";

@Component({
	selector: 'fb-email-verfication-status',
	templateUrl: './email-verfication-status.component.html',
	styleUrls: ['./email-verfication-status.component.scss']
})
export class EmailVerficationStatusComponent implements OnInit, OnDestroy {

	public isLoading: boolean = true;
	public emailVerified: boolean = false;
	public authSubscription: Subscription = {} as Subscription;

	constructor(
		private _toast: ToastMessageService,
		private _activeRoute: ActivatedRoute,
		private _fabricAuth: AuthenticationService
	) {
	}

	public ngOnInit(): void {
		this.authSubscription = this._activeRoute.params.subscribe(params => {
			this._verifyEmail(params['verifyEmailToken']);
		});
	}

	private _verifyEmail(token: string): void {
		this._fabricAuth.verifyEmailTokenAndLogin(
			token,
			() => {
				this.emailVerified = true;
				this._toast.success('Email Verified Successfully!', 'You\'ll be automatically signed in');
			},
			() => {
				this.emailVerified = false;
			},
			() => {
				this.isLoading = false;
			},
		)
	}

	ngOnDestroy() {
		this.authSubscription.unsubscribe();
	}
}
